// Apolo IDE — keyboard shortcuts for the session workspace.
//
// ⌘` (Cmd+Backtick): toggle the side panel.
// ⇧⌘P : focus the Preview tab.
// ⇧⌘D : focus the Diff tab.
// ⇧⌘F : focus the Files tab.
// ⇧⌘L : focus the Learning tab (Sprint v3 L6).
// ⇧⌘B : focus the Brain tab (Sprint v2 B6).
// ⇧⌘A : focus the MultiAgent Panel tab (Sprint v4 Epic S5).
// ⇧⌘E : focus the Adapters tab (Sprint v5 A1 — "Endpoints"; D/P already bound).
//
// All shortcuts are no-ops when an input/textarea/contenteditable is focused
// so typing is never hijacked.

import { useEffect } from 'react';

function targetIsTypingTarget(target) {
  if (!target) return false;
  if (target.isContentEditable) return true;
  const tag = target.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT';
}

export function useSessionShortcuts({ togglePanel, openTab }) {
  useEffect(() => {
    function handler(e) {
      if (targetIsTypingTarget(e.target)) return;
      const meta = e.metaKey || e.ctrlKey;
      const shift = e.shiftKey;
      if (!meta) return;

      if (e.key === '`' && !shift) {
        e.preventDefault();
        togglePanel?.();
        return;
      }
      if (shift && (e.key === 'p' || e.key === 'P')) {
        e.preventDefault();
        openTab?.('preview');
        return;
      }
      if (shift && (e.key === 'd' || e.key === 'D')) {
        e.preventDefault();
        openTab?.('diff');
        return;
      }
      if (shift && (e.key === 'f' || e.key === 'F')) {
        e.preventDefault();
        openTab?.('files');
        return;
      }
      if (shift && (e.key === 'l' || e.key === 'L')) {
        e.preventDefault();
        openTab?.('learning');
        return;
      }
      if (shift && (e.key === 'b' || e.key === 'B')) {
        e.preventDefault();
        openTab?.('brain');
        return;
      }
      // S5: ⇧⌘A opens the MultiAgent Panel tab.
      if (shift && (e.key === 'a' || e.key === 'A')) {
        e.preventDefault();
        openTab?.('agents');
        return;
      }
      // Sprint v5 A1: ⇧⌘E opens the Adapters catalog tab.
      if (shift && (e.key === 'e' || e.key === 'E')) {
        e.preventDefault();
        openTab?.('adapters');
        return;
      }
      // Sprint v6 B3: ⇧⌘T opens the global ScheduleModal via custom event
      // so any mounted listener (App.jsx) can show it without prop-drilling.
      if (shift && (e.key === 't' || e.key === 'T')) {
        e.preventDefault();
        window.dispatchEvent(new CustomEvent('apolo:openSchedule'));
      }
    }
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [togglePanel, openTab]);
}
